import { Dropdown, List } from "antd";
import { useEffect, useState } from "react";
import { AiFillPlusCircle, AiOutlineQuestionCircle } from "react-icons/ai";
import { FiPlusCircle } from "react-icons/fi";
import { PiSealCheck } from "react-icons/pi";
import { SlOptionsVertical } from "react-icons/sl";
import { useDispatch, useSelector } from "react-redux";
import styles from "./groupAssets.module.css";
import EditAssets from "../../EditAsset/EditAsset";
import TrackingModal from "../../TrackingModal/TrackingModal";
import AddGroupAssetModal from "../../AddGroupAsset/AddGroupAsset";
import EditGroupAssetModal from "../../EditGroupAsset/EditGroupAsset";
import AddNewGroupAssetModal from "../../AddGroupAsset/AddNewGroupAsset";
import GroupSchedule from "../ScheduleModal/GroupSchedule";
import GroupEditSchedule from "../ScheduleModal/GroupEditSchedule";
import {
  group_assets_details,
  set_status_of_group_asset,
} from "../../../../../Store/Actions/AssetsAction";
import { AssetsMiddleware } from "../../../../../Store/Middlewares/AssetsMiddleware";
import { extractBytes, hexToBase64 } from "../../../../../utills";
import { Modal, TextComponent } from "../../../../../components";
import { ScheduleMiddleware } from "../../../../../Store/Middlewares/ScheduleMiddleware";
import Switch from "../../../../../components/Switch/Switch";
import Card from "../../../../../components/Card/Card";
import imagePlaceholder from "../../../../../assets/images/imageplace.jpg";
import { FaArrowAltCircleLeft } from "react-icons/fa";

const GroupAssetDetails = ({
  add_asset,
  is_immobilized,
  user,
  group_immobilizer,
  group_data,
  setGroupAssetDetail,
}) => {
  const dispatch = useDispatch();
  const [openEditAssetsModal, setOpenEditAssetsModal] = useState(false);
  const [locationTracking, setLocationTracking] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [success, setSuccess] = useState(false);
  const [openAddGroupAsset, setOpenAddGroupAsset] = useState(false);
  const [openEditGroupAsset, setOpenEditGroupAsset] = useState(false);
  const [openAddNewGroupAsset, setOpenAddNewGroupAsset] = useState(false);
  const [scheduleModal, setScheduleModal] = useState(false);
  const [editScheduleModal, setEditScheduleModal] = useState(false);
  const [schedule, setScheduleData] = useState(null);

  const GroupAssetDetail = useSelector(
    (state) => state.AssetsReducer.groupAssetDetails,
  );

  const getGroupStatus = useSelector(
    (state) => state.AssetsReducer.setAssetsGroupStatus,
  );

  const getGroupVehicles = useSelector(
    (state) => state.AssetsReducer?.getGroupVehiclesByGroupID,
  );
  const getGroupVehicelDetails = useSelector(
    (state) => state.AssetsReducer?.getgroupvehicledetails,
  );

  const [assetDetails, setAssetdetails] = useState(null);
  const [groupAssetDetails, setGroupAssetdetails] = useState(null);

  const setStatusOfGroupAsset = useSelector(
    (state) => state.AssetsReducer.setStatusOfGroupAsset,
  );

  const items = [
    {
      key: "1",
      label: <a onClick={() => setOpenEditGroupAsset(true)}>Edit details</a>,
    },
    {
      key: "2",
      label: <a onClick={() => setDeleteModal(true)}>Delete group</a>,
    },
  ];

  useEffect(() => {
    dispatch(AssetsMiddleware.getAssetGroup()).then((data) => {
      const firstGroup = data?.data?.data[0];
      group_assets_details(firstGroup);
    });
  }, []);

  useEffect(() => {
    if (GroupAssetDetail) {
      setAssetdetails(GroupAssetDetail.assets?.[0]);
    }
  }, [GroupAssetDetail]);

  useEffect(() => {
    if (assetDetails) {
      dispatch(
        set_status_of_group_asset({
          device_id: assetDetails?.device_id,
          status: assetDetails?.status,
        }),
      );
    }
  }, [assetDetails]);

  const onClickGroupImmobilized = () => {
    dispatch(
      AssetsMiddleware.sentGroupDownlink({
        group_id: GroupAssetDetail?.id,
        action: getGroupStatus?.status != "immobilized" ? "A1" : "A2",
        status:
          getGroupStatus?.status == "immobilized" ? "drive" : "immobilized",
      }),
    );
  };

  const onClickGetDetail = (id) => {
    dispatch(AssetsMiddleware.getAssetsGroupDetails(id)).then((data) => {
      group_assets_details(data?.data?.data);
    });
  };

  const onClickGetGroupAssets = (id) => {
    dispatch(AssetsMiddleware.getAssetsByGroupId({ id: id })).then((data) => {
      console.log(data?.data?.data?.data?.[0]);
      const getData = data?.data?.data?.data;
      const id = getData[0]?.id;
      if (id) onClickGetGroupVehicleDetails(id);
    });
  };

  const onClickGetGroupVehicleDetails = (id) => {
    dispatch(AssetsMiddleware.getVehicleDetailByID({ id: id }));
  };

  const onClickImmobilized = () => {
    dispatch(
      AssetsMiddleware.sentDownlinkOfGroupAss({
        device_id: assetDetails?.device_id,
        action:
          setStatusOfGroupAsset?.status != "immobilized"
            ? hexToBase64(extractBytes(assetDetails.dev_eui) + "A1")
            : hexToBase64(extractBytes(assetDetails.dev_eui) + "A2"),
        status:
          setStatusOfGroupAsset?.status == "immobilized"
            ? "drive"
            : "immobilized",
        asset_id: assetDetails?.id,
      }),
    ).then((data) => {
      let findUpdatedItem = data?.find((x) => x?.id == GroupAssetDetail?.id);
      let findUpdatedAssets = findUpdatedItem?.assets?.find(
        (x) => x?.id == assetDetails?.id,
      );
      dispatch(
        set_status_of_group_asset({
          device_id: findUpdatedAssets?.device_id,
          status: findUpdatedAssets?.status,
        }),
      );
    });
  };

  const renderItem = (item) => {
    return (
      <div
        className={`
          ${styles.subcont} 
        ${getGroupVehicelDetails?.id == item?.id ? styles.active : ""}`}
        onClick={() => onClickGetGroupVehicleDetails(item?.id)}
        key={item?.id}
      >
        <div className={styles.assest_data}>
          <TextComponent
            text={
              item?.name
                ? item?.name
                : item?.make && item?.model && `${item?.make} ${item?.model}`
            }
            className={`${styles.heading} ${getGroupVehicelDetails?.id == item?.id ? styles.textactive : ""}`}
          />
          <TextComponent text={item?.vin_no ? item?.vin_no : ""} />
        </div>
      </div>
    );
  };

  const renderItemScedule = (item) => {
    const items3 = [
      {
        key: "3",
        label: (
          <a
            onClick={() => {
              setEditScheduleModal(true);
              setScheduleData(item);
            }}
          >
            Edit details
          </a>
        ),
      },
      {
        key: "4",
        label: (
          <a
            onClick={() => {
              dispatch(
                ScheduleMiddleware.deleteGroupSchedule({
                  id: item?.id,
                  groupID: GroupAssetDetail?.id,
                }),
              );
            }}
          >
            Delete
          </a>
        ),
      },
    ];
    return (
      <div className={`${styles.scheduleCont}`}>
        <div>
          <TextComponent
            text={item?.name ? item?.name : "--"}
            className={styles.heading}
          />
          <div className={styles.scheduleLeftCont}>
            {/* <TextComponent
              text={item?.frequency == "one_time" ? "One time" : "Daily"}
              className={styles.text}
            /> */}
            <TextComponent
              text={`${item?.start_time}-${item?.end_time}`}
              className={styles.scheduleTime}
            />
            {user?.is_owner || add_asset?.is_access == 1 ? (
              <Switch
                isChecked={item.status == "active"}
                size="small"
                onChange={() => {
                  dispatch(
                    ScheduleMiddleware.updateScheduleGroupStatus({
                      id: item?.id,
                    }),
                  );
                }}
                // disabled={!user?.is_owner || add_asset?.is_access == 1}
              />
            ) : null}
          </div>
        </div>
        {user?.is_owner || add_asset?.is_access == 1 ? (
          <div className={styles.mobStatusCont}>
            <Dropdown
              trigger={"click"}
              menu={{
                items: items3,
              }}
              placement="bottomRight"
              arrow={{
                pointAtCenter: true,
              }}
            >
              <button className={styles.menubtn}>
                <SlOptionsVertical
                  size={20}
                  color="var(--light-text)"
                  cursor={"pointer"}
                />
              </button>
            </Dropdown>
          </div>
        ) : null}
      </div>
    );
  };

  useEffect(() => {
    onClickGetDetail(group_data?.id);
    onClickGetGroupAssets(group_data?.id);
  }, []);

  return (
    <div className={styles.mainCont}>
      <div className={styles.leftCol}>
        <Card className={styles.card}>
          <div className={styles.header}>
            <div className={styles.headback}>
              <FaArrowAltCircleLeft
                onClick={() => setGroupAssetDetail(null)}
                size={20}
                style={{ cursor: "pointer", color: "var(--dark-grey)" }}
              />
              <TextComponent
                text={group_data?.name ? group_data?.name : "-"}
                className={styles.heading}
              />
            </div>
          </div>

          <List dataSource={getGroupVehicles?.data} renderItem={renderItem} />
        </Card>
        <Card className={styles.card}>
          <div className={styles.header}>
            <TextComponent text={"Schedule"} className={styles.heading} />
            {user?.is_owner || add_asset?.is_access == 1 ? (
              <div
                className={styles.btnScedule}
                onClick={() => setScheduleModal(true)}
              >
                <TextComponent text={"Add"} className={styles.carDescText} />
                <AiFillPlusCircle
                  size={18}
                  style={{ marginLeft: "5px" }}
                  color="var(--primary-color)"
                />
              </div>
            ) : null}
          </div>

          <List
            dataSource={GroupAssetDetail?.schedules}
            renderItem={renderItemScedule}
          />
        </Card>
      </div>

      {/* {GroupAssetDetail && ( */}
      <div className={styles.rightCol}>
        <Card className={styles.card1}>
          <div className={styles.leftHeader}>
            <TextComponent
              text={GroupAssetDetail?.name}
              className={styles.heading}
            />
            {user?.is_owner || add_asset?.is_access == 1 ? (
              <Dropdown
                trigger={"click"}
                menu={{
                  items,
                }}
                placement="bottomRight"
                arrow={{
                  pointAtCenter: true,
                }}
              >
                <button className={styles.menubtn}>
                  <SlOptionsVertical
                    size={18}
                    color="var(--light-text)"
                    cursor={"pointer"}
                  />
                </button>
              </Dropdown>
            ) : null}
          </div>
          {getGroupVehicles?.data?.length > 0 ? (
            <div className={styles.immobilizedCont}>
              {user?.is_owner || group_immobilizer?.is_access == 1 ? (
                <Switch
                  initialChecked={
                    getGroupStatus?.status == "immobilized" ? true : false
                  }
                  isChecked={
                    getGroupStatus?.status == "immobilized" ? true : false
                  }
                  onChange={onClickGroupImmobilized}
                  // disabled={is_immobilized?.is_access == 0 || !user?.is_owner }
                />
              ) : null}

              <TextComponent
                text={
                  getGroupStatus?.status == "immobilized"
                    ? "Immobilized"
                    : "Drive"
                }
                className={styles.text1}
              />
            </div>
          ) : (
            <TextComponent
              text={"No assets in this group"}
              className={styles.noAssetText}
            />
          )}
        </Card>
        {getGroupVehicles?.data?.length > 0 && (
          <>
            <Card>
              <img
                src={
                  getGroupVehicelDetails?.image
                    ? getGroupVehicelDetails?.image
                    : imagePlaceholder
                }
                alt="////////"
                className={styles.slectedImg}
              />
              <div className={styles.leftHeader}>
                <div>
                  <TextComponent
                    text={`${getGroupVehicelDetails?.make || "--"} ${getGroupVehicelDetails?.model || "--"}`}
                    className={styles.heading}
                  />
                  <TextComponent
                    text={`License No: ${
                      getGroupVehicelDetails?.license_no
                        ? getGroupVehicelDetails?.license_no
                        : "--"
                    }`}
                    className={styles.carDescText}
                  />
                  <TextComponent
                    text={`VIN: ${
                      getGroupVehicelDetails?.vin_no
                        ? getGroupVehicelDetails?.vin_no
                        : "--"
                    }`}
                    className={styles.carDescText}
                  />
                  <div className={styles.scheduleLeftCont}>
                    {user?.is_owner || is_immobilized?.is_access == 1 ? (
                      <Switch
                        isChecked={
                          setStatusOfGroupAsset?.status == "immobilized"
                            ? true
                            : false
                        }
                        size="small"
                        onChange={onClickImmobilized}
                      />
                    ) : null}
                    <TextComponent
                      text={
                        setStatusOfGroupAsset?.status == "immobilized"
                          ? "Immobilized"
                          : "Drive"
                      }
                      className={styles.text}
                    />
                  </div>
                </div>
              </div>
            </Card>
          </>
        )}
      </div>
      {/* )} */}
      <EditAssets
        isOpen={openEditAssetsModal}
        setIsOpen={setOpenEditAssetsModal}
      />
      <TrackingModal
        locationTracking={locationTracking}
        setLocationTracking={setLocationTracking}
        assets={[1, 2, 3, 4]}
      />
      {/* <AddAssets
        isOpen={openAddAssetsModal}
        setIsOpen={setOpenAddAssetsModal}
      /> */}
      <AddGroupAssetModal
        isOpen={openAddGroupAsset}
        setIsOpen={setOpenAddGroupAsset}
      />

      <EditGroupAssetModal
        isOpen={openEditGroupAsset}
        setIsOpen={setOpenEditGroupAsset}
        details={GroupAssetDetail}
        resetAssets={() => onClickGetGroupAssets(GroupAssetDetail?.id)}
      />
      <AddNewGroupAssetModal
        isOpen={openAddNewGroupAsset}
        setIsOpen={setOpenAddNewGroupAsset}
      />
      <GroupSchedule
        scheduleModal={scheduleModal}
        setScheduleModal={setScheduleModal}
        details={GroupAssetDetail}
      />
      <GroupEditSchedule
        scheduleModal={editScheduleModal}
        setScheduleModal={setEditScheduleModal}
        details={GroupAssetDetail}
        scheduleData={schedule}
      />

      <Modal
        open={deleteModal}
        onCancel={() => {
          setDeleteModal(false);
        }}
        icon={
          <AiOutlineQuestionCircle
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        }
        twoButton
        okBtnTitle={"Yes, delete"}
        cancelBtnTitle={"No, go back"}
        title={"Are you sure"}
        text={"You want to delete this Group?"}
        width={400}
        // btnDiv={styles.access_modalBtn}
        onClickCancelButton={() => {
          setDeleteModal(false);
        }}
        onClickOkButton={() => {
          dispatch(
            AssetsMiddleware.deleteAssetGroup(GroupAssetDetail?.id),
          ).then(() => {
            setSuccess(true);
            setDeleteModal(false);
            setGroupAssetDetail(null);
            // if(GroupAssets?.length != 0){
            //   setGroupAssetDetail(GroupAssets[0])
            // }else{
            //   setGroupAssetDetail()
            // }
          });
        }}
        headingClass={styles.modalHeading}
      ></Modal>
      <Modal
        open={success}
        onCancel={() => setSuccess(false)}
        icon={
          <PiSealCheck
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        }
        title={"Group Deleted successfully"}
        width={"300px"}
        buttonTitle={"Continue"}
        onBtnPress={() => {
          setSuccess(false);
        }}
        headingClass={styles.modalHeading}
      ></Modal>
    </div>
  );
};

export default GroupAssetDetails;
